const discount = {
  defaults: {
    discountId: '',
  },
}

export default discount
